import { useSaveContext } from "ra-core";
import { FC, ReactElement } from "react";
import { useSimpleSaveAction } from "./SaveContextProvider";


const WithSave : FC<{render: (x:{save:(record: any, callbacks?: any) => void, saving:boolean}) => ReactElement|null}> = ({ render }) => {
  const save = useSimpleSaveAction()
  const { saving } = useSaveContext()
  return render({ save, saving: Boolean(saving) })
}


export default WithSave;
